import { useState } from "react";

export default function AirlinesFilter({ filterTags , filterDefinition, onChange }) {
  const [selected, setSelected] = useState({});

  const [showAll, setShowAll] = useState(false);

  const maxVisible = 4;

  const displayedOptions = showAll
    ? filterDefinition.options
    : filterDefinition.options.slice(0, maxVisible);

  const handleCheckboxChange = (option) => {
    const isSelected = filterTags.some(
      (tag) => tag.key === `airline:${option.iata}`
    );

    let newFilterTags;
    if (isSelected) {
      newFilterTags = filterTags.filter(
        (tag) => tag.key !== `airline:${option.iata}`
      );
    } else {
      newFilterTags = [
        ...filterTags,
        { key: `airline:${option.iata}`, label: option.name },
      ];
    }

    if (onChange) {
      onChange(!isSelected, option);
    }
  };

  return (
    <div className="wrap-box">
      <h6>Airlines</h6>
      {displayedOptions.map((option, i) => (
        <div className="form-check" key={i}>
          <input
            className="form-check-input"
            type="checkbox"
            id={`popular-${i}`}
            checked={filterTags.some((tag) => tag.key === `airline:${option.iata}`)}
            onChange={() => handleCheckboxChange(option)}
          />

          <label
            className="form-check-label d-flex align-items-center w-100"
            htmlFor={`popular-${i}`}
          >
            <img
              src={option.logo || "/images/icons/flight-icon.svg"}
              alt={option.name}
              style={{
                width: "16px",
                height: "16px",
                objectFit: "contain",
              }}
            />
            <span style={{ marginLeft: 4, fontWeight: 400, fontSize: '14px' }}>{`${option.name} (${option.count})`}</span>
            <span style={{ marginLeft: "auto", color: "#4f5563", fontSize: '13px', fontWeight: 600 }}>
              {option.displayLowestPrice}
            </span>
          </label>
        </div>
      ))}

      {filterDefinition.options.length > maxVisible && (
        <button
          type="button"
          className="d-block mt-2 text-primary btn btn-link p-0"
          style={{ fontSize: "14px" }}
          onClick={() => setShowAll((prev) => !prev)}
        >
          {/* {showAll ? "Show Less" : `Show All (${filterDefinition.options.length})`} */}
          {showAll ? "Show Less" : `Show All`}
        </button>
      )}
    </div>
  );
}